<lms-breadcrumb [crumbs]="[{ label: 'Games Activity', icon: 'glicon-misc', route: '.' }]"></lms-breadcrumb>

<div [ngStyle]="{ width: '30%' }" class="margin-top"></div>

<div>
  <gl-button color-primary text="Ver elementos activos (mongoose)" (onClick)="getActivityByMongoose()"></gl-button>

  <gl-button color-primary text="Ver elementos activos (crawler)" (onClick)="getActivityByCrawler()"></gl-button>
</div>

<div>
  <table [ngStyle]="{ float: 'left', width: '40%' }">
    <th>Juego</th>
    <th>Licencias activas</th>
    <tr *ngFor="let item of licensesResult$ | async">
      <td>{{ item.name }}</td>
      <td>{{ item.count }}</td>
    </tr>
  </table>

  <table [ngStyle]="{ float: 'left', width: '40%' }">
    <th>Juego</th>
    <th>Grupos activos</th>
    <tr *ngFor="let item of groupsResult$ | async">
      <td>{{ item.name }}</td>
      <td>{{ item.count }}</td>
    </tr>
  </table>
</div>
